export class BorrowerOpenedEvent {
  constructor(
      public id: number,
      public name: string,
      public stage: string
    ) {}
}
